import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Checkbox } from 'semantic-ui-react';

import {
  updateProhibitedItem,
  checkAllProhibitedItems,
} from '../state/actions';
import { forceDirtyState } from 'State/dirtyTracking/actions';

import { TrackedCheckbox } from 'Components';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';

class ProhibitedItemsGridContainer extends Component {
  state = {
    checkAllChecked: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.mealType !== this.props.mealType) {
      this.onFilteredChange();
    }
  }

  columns = [
    {
      columns: [
        {
          Header: 'Id',
          accessor: 'ItemId',
          filterable: true,
          maxWidth: 120,
        },
        {
          Header: 'Description',
          accessor: 'ItemDescription',
          filterable: true,
        },
        {
          Header: 'Nutrition Code',
          accessor: 'NutritionCode',
          filterable: true,
          maxWidth: 120,
        },
        {
          Header: currentRows => {
            const { checkAllProhibitedItems } = this.props;
            const { checkAllChecked } = this.state;

            return (
              <SecurityPreferences scope={PrefEnum.ModifyProhibitedItems}>
                {disabled => {
                  return (
                    <Checkbox
                      checked={checkAllChecked}
                      onClick={(e, data) => {
                        this.props.forceDirtyState();
                        this.setState({ checkAllChecked: !checkAllChecked });
                        checkAllProhibitedItems(data.checked, currentRows.data);
                      }}
                      disabled={disabled}
                    />
                  );
                }}
              </SecurityPreferences>
            );
          },
          accessor: 'IsProhibited',
          maxWidth: 120,
          Cell: ({ original }) => {
            const { initialData } = this.props;
            const initialValue = initialData.find(
              x => x.ItemId === original.ItemId
            ).IsProhibited;

            return (
              <div style={{ textAlign: 'center' }}>
                <SecurityPreferences scope={PrefEnum.ModifyProhibitedItems}>
                  {disabled => {
                    return (
                      <TrackedCheckbox
                        initialValue={initialValue}
                        checked={original.IsProhibited}
                        disabled={disabled}
                        onChange={() =>
                          this.props.updateProhibitedItem(original)
                        }
                      />
                    );
                  }}
                </SecurityPreferences>
              </div>
            );
          },
        },
      ],
    },
  ];

  defaultSorted = [
    {
      id: 'ItemDescription',
      desc: false,
    },
  ];

  onFilteredChange = () => this.setState({ checkAllChecked: false });

  render() {
    const { loading, data, mealType } = this.props;
    return (
      <ReactTable
        loading={loading}
        data={data.filter(i => i.ItemId.startsWith(mealType))}
        className="-striped -highlight modalGrid"
        defaultPageSize={15}
        showPageSizeOptions={false}
        minRows={15}
        defaultSorted={this.defaultSorted}
        resizable={false}
        columns={this.columns}
        defaultFilterMethod={caseInsensitiveFilter}
        onFilteredChange={this.onFilteredChange}
      />
    );
  }
}

const mapStateToProps = ({ AccountSetupState }) => {
  return {
    initialData: AccountSetupState.initialProhibitedItemsData,
    data: AccountSetupState.prohibitedItemsData,
    loading: AccountSetupState.prohibitedItemsLoading,
  };
};

export const ProhibitedItemsGrid = connect(
  mapStateToProps,
  {
    updateProhibitedItem,
    checkAllProhibitedItems,
    forceDirtyState,
  }
)(ProhibitedItemsGridContainer);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/ProhibitedItemsGrid.js